import { useState, useContext } from 'react'
import BookingRoom from './components/BookingRoom'
import Payment from './components/Payment'
import { Steps } from 'antd';
import { Link, useHistory, useParams, Route, useLocation } from 'react-router-dom';
import Footer from '../../layout/Footer';
function useStep() {
    const params = new URLSearchParams(useLocation().search);
    return parseInt(params.get("step"), 10);
}
const StepContent = () => {
    const step = useStep();
    var valueSearch = JSON.parse(localStorage.getItem("valueSearch"));
    var dateValue = JSON.parse(localStorage.getItem("dateValue"));
    if (step === 1) {
        return <BookingRoom valueSearch={valueSearch} dateValue={dateValue}/>
    } else if (step === 2) {
        return <Payment valueSearch={valueSearch} dateValue={dateValue}/>
    }
    else{
        return <div></div>
    }
};
function BookingSearch({ match }) {
    const { Step } = Steps;
    const [screenWidth, setScreenWidth] = useState(window.innerWidth);
    const history = useHistory();
    const step = useStep();
    const [current, setCurrent] = useState(step);

    function onChange(current) {
        setCurrent(current);
        history.push(`${match.path}?step=${current}`);
    };

    window.addEventListener('resize', handleResize)
    function handleResize() {
        setScreenWidth(window.innerWidth)
    }

    return (
        < >
            <div className="stepBooking">
                <div className="container">
                    <div className="stepContainer">
                        <Link to='/' className="logo"><img className="img-fluid " src="/images/logo.png" alt="" /></Link>
                        <div className="row">
                            {screenWidth > 992 &&
                                <div className="col-lg-2 colBox hotelCol">
                                    <Link className="hotelText" to='/'><img classname="img-fluid" src="/images/ic_arrow1.png" alt="" /> Khách sạn</Link>
                                </div>
                            }
                            <div className={screenWidth < 992 ? "col-lg-7 ant-col-offset-6 colBox stepCol" : "col-lg-7 colBox stepCol"}>
                                <Steps className="stepBox" current={current} type="navigation" onChange={onChange}>
                                    <Step title={<Link to="/">
                                        Chọn khách sạn
                                    </Link>} status="finish" />
                                    <Step title="Đặt phòng" />
                                    <Step title="Thanh toán" />
                                </Steps>
                            </div>
                            {screenWidth < 992 &&
                                <div className="col-6 colBox hotelCol">
                                    <Link className="hotelText" to='/'><img classname="img-fluid" src="/images/ic_arrow1.png" alt="" /> Khách sạn</Link>
                                </div>
                            }
                            <div className="col-lg-3 col-6 colBox cancelBooking" ><Link to="/"><span >Hủy đặt phòng </span><img classname="img-fluid" src="/images/close.png" alt="" /></Link></div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="stepContent">
                <div className="container">
                    <Route path={`${match.path}`} exact component={StepContent} />
                </div>
            </div>
            <Footer />
        </>
    );
}
export default BookingSearch;